
import * as z from "zod";

export const consultationFormSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Please enter a valid email address"),
  company: z.string().min(1, "Company name is required"),
  message: z.string().min(10, "Please provide at least 10 characters").max(500),
  consultationDate: z.string().min(1, "Please select a preferred date and time"),
  timezone: z.string({
    required_error: "Please select your timezone",
  }),
  consent: z.boolean().refine(val => val === true, {
    message: "You must agree to be contacted",
  }),
});

export type ConsultationFormValues = z.infer<typeof consultationFormSchema>;

// Industry options
export const industryOptions = [
  { value: "law-firm", label: "Law Firm" },
  { value: "corporate-legal", label: "Corporate Legal Department" },
  { value: "government", label: "Government Legal" },
  { value: "legal-tech", label: "Legal Technology" },
  { value: "judiciary", label: "Judiciary" },
  { value: "legal-education", label: "Legal Education" },
  { value: "other", label: "Other" },
];

// Use case options
export const useCaseOptions = [
  { value: "document-analysis", label: "Document Analysis & Review" },
  { value: "legal-research", label: "Legal Research" },
  { value: "contract-management", label: "Contract Management" },
  { value: "case-management", label: "Case Management" },
  { value: "client-intake", label: "Client Intake & Management" },
  { value: "compliance", label: "Regulatory Compliance" },
  { value: "ip-management", label: "Intellectual Property Management" },
  { value: "litigation-support", label: "Litigation Support" },
  { value: "legal-analytics", label: "Legal Analytics" },
  { value: "other", label: "Other" },
];

// Timezone options
export const timezoneOptions = [
  { value: "GMT-8", label: "Pacific Time (PT)" },
  { value: "GMT-7", label: "Mountain Time (MT)" },
  { value: "GMT-6", label: "Central Time (CT)" },
  { value: "GMT-5", label: "Eastern Time (ET)" },
  { value: "GMT-4", label: "Atlantic Time" },
  { value: "GMT", label: "Greenwich Mean Time (GMT)" },
  { value: "GMT+1", label: "Central European Time (CET)" },
  { value: "GMT+2", label: "Eastern European Time (EET)" },
  { value: "GMT+3", label: "Moscow Time" },
  { value: "GMT+5:30", label: "India Standard Time" },
  { value: "GMT+8", label: "China Standard Time" },
  { value: "GMT+9", label: "Japan Standard Time" },
  { value: "GMT+10", label: "Australian Eastern Time" },
  { value: "GMT+12", label: "New Zealand Time" },
];

// Prefilled time slots
export const timeSlotOptions = [
  { value: "9:00", label: "9:00 AM" },
  { value: "10:00", label: "10:00 AM" },
  { value: "11:00", label: "11:00 AM" },
  { value: "12:00", label: "12:00 PM" },
  { value: "13:00", label: "1:00 PM" },
  { value: "14:00", label: "2:00 PM" },
  { value: "15:00", label: "3:00 PM" },
  { value: "16:00", label: "4:00 PM" },
];
